import { UserAction } from "../app-constants/index.js";


const userSettingsDefault = {
    isUpdatingUserDetails: false,
    isFetchingUserDetails: false,
    featurePermision: [],
    authorProfile: null,
    isFetchingAuthorProfile: false,
    isSavingAuthorProfile: false,
}
const userSettings = (state = userSettingsDefault, action) => {
    switch (action.type) {
        case UserAction.USER.UPDATE_PROFILE.REQUEST: {
            return { ...state, isUpdatingUserDetails: true }
        }
        case UserAction.USER.UPDATE_PROFILE.SUCCESS: {
            return { ...state, isUpdatingUserDetails: false }
        }
        case UserAction.USER.UPDATE_PROFILE.FAILURE: {
            return { ...state, isUpdatingUserDetails: false }
        }

        //getting user details
        case UserAction.SET.USER_DATA.REQUEST: {
            return { ...state, isFetchingUserDetails: true }
        }
        case UserAction.SET.USER_DATA.FAILURE: {
            return { ...state, isFetchingUserDetails: false }
        }
        case UserAction.SET.USER_DATA.SUCCESS: {
            return { ...state, isFetchingUserDetails: false }
        }

        // Author Profile
        case UserAction.AUTHOR_PROFILE.FETCH.REQUEST: {
            return { ...state, isFetchingAuthorProfile: true }
        }
        case UserAction.AUTHOR_PROFILE.FETCH.SUCCESS: {
            return { ...state, isFetchingAuthorProfile: false, authorProfile: action.authorProfile }
        }
        case UserAction.AUTHOR_PROFILE.FETCH.FAILURE: {
            return { ...state, isFetchingAuthorProfile: false }
        }
        case UserAction.AUTHOR_PROFILE.SAVE.REQUEST: {
            return { ...state, isSavingAuthorProfile: true }
        }
        case UserAction.AUTHOR_PROFILE.SAVE.SUCCESS: {
            return { ...state, isSavingAuthorProfile: false, authorProfile: action.authorProfile }
        }
        case UserAction.AUTHOR_PROFILE.SAVE.FAILURE: {
            return { ...state, isSavingAuthorProfile: false }
        }
        default: return state;
    }

}



export default userSettings;